import api from "./api";

class AuthService {
  login(username, password) {
    return api
      .post("/auth/signin", { username, password })
      .then((response) => {
        // Store user info (no token — it's in httpOnly cookies)
        if (response.data.id) {
          localStorage.setItem("user", JSON.stringify(response.data));
        }
        return response.data;
      });
  }

  logout() {
    return api
      .post("/auth/logout")
      .then(() => {
        localStorage.removeItem("user");
      })
      .catch(() => {
        // Clear local state even if server call fails
        localStorage.removeItem("user");
      });
  }

  register(username, email, password) {
    return api.post("/auth/signup", { username, email, password });
  }

  /**
   * Returns the locally cached user info.
   * Note: this does NOT validate the session — use verifySession() for that.
   */
  getCurrentUser() {
    return JSON.parse(localStorage.getItem("user"));
  }

  /**
   * Verify the session is still valid by calling the /me endpoint.
   * Updates the local cache with fresh user info from the server.
   * Returns null if session is invalid.
   */
  async verifySession() {
    try {
      const response = await api.get("/auth/me");
      localStorage.setItem("user", JSON.stringify(response.data));
      return response.data;
    } catch (err) {
      localStorage.removeItem("user");
      return null;
    }
  }
}

export default new AuthService();
